import {Component} from '@angular/core';
import {WebPage} from 'src/app/ui/webapp/page/web.page';

@Component({
  selector: 'app-not-found-error',
  templateUrl: 'not-found-error.page.html',
})
export class NotFoundErrorPage extends WebPage {
  public goHome(): void {
    this.navigate('/');
  }
}
